import dayjs from 'dayjs'
import { ChatParticipant } from 'helpers'
import { CHAT_ID } from 'navigation/CONSTANTS'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getChatList } from 'services/chat'
import {
  ChatNotifications,
  useFirebaseListener
} from 'services/context/firebaseListener'
import Storage from 'storage/auth'
import { removeAccents } from 'utils/formatString'

const useChat = () => {
  const [state, setState] = useState<IStateStdTypes>('idle')
  const [filter, setFilter] = useState<string>('')
  const [chats, setChats] = useState<Array<ChatParticipant>>([])
  const location = useLocation()
  const { chatNotifications } = useFirebaseListener()

  const fbListener = useFirebaseListener()

  const path = location.pathname.split('/')

  const user = Storage.user.get()
  const navigate = useNavigate()

  const sortChats = (chatsList: Array<ChatParticipant>) => {
    const fbChats = chatNotifications ?? ({} as ChatNotifications)
    chatsList.sort((current, next) => {
      const datetime1 = fbChats[current.chat_id]?.lastUpdated
      const datetime2 = fbChats[next.chat_id]?.lastUpdated

      const chat1 = datetime1 ? dayjs(datetime1) : undefined
      const chat2 = datetime2 ? dayjs(datetime2) : undefined

      return (chat2?.valueOf() ?? 0) - (chat1?.valueOf() ?? 0)
    })
    setChats(chatsList)
  }

  useEffect(() => {
    sortChats([...chats])
  }, [chatNotifications])

  const getLastMessage = (chatId: string): string | boolean => {
    let lastMessage: string | false = false

    if (fbListener.chatNotifications) {
      lastMessage = fbListener.chatNotifications[chatId]?.lastMessage
    }
    return lastMessage
  }

  const getCount = (chatId: string): number => {
    let lastMessage: number = 0

    if (fbListener.chatNotifications) {
      lastMessage = fbListener.chatNotifications[chatId]?.count
    }
    return lastMessage
  }

  const openChat = (chat: ChatParticipant) => {
    navigate(CHAT_ID(chat.chat_id), {
      replace: true,
      state: chat
    })
  }

  useEffect(() => {
    const fetchChatData = async () => {
      const response = await getChatList(user?.professional_id)

      if (response.success && response.data) {
        const data = Object.entries(response.data!).map(
          ([key, value]) => new ChatParticipant(key, value)
        )
        sortChats(data)
        setState('success')
      } else {
        setState('error')
      }
    }

    fetchChatData()
  }, [location])

  return {
    chats: chats.filter(chat => {
      const fullName = removeAccents(chat.fullName)

      return fullName
        .toLocaleLowerCase()
        .includes(removeAccents(filter).toLocaleLowerCase())
    }),
    setFilter,
    state,
    openChat,
    pathLeaf: path[path.length - 1],
    getLastMessage,
    getCount
  }
}

export default useChat
